import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import reduxThunk from "redux-thunk";
import Header from "./components/Header/index.jsx";
import Marketplace from "./components/Marketplace/index.jsx";
import Announcement from "./Announcement";
import Passport from "./components/Passport/";
import QRGen from "./qrgen";
import Media from "./components/Media";
import { isMobile } from "react-device-detect";

import reducers from "./reducers";
import {
  initSocket,
  initPrices,
  initMempool,
  initDiscovery,
  initStorage,
} from "./init";
import { settings } from "./config";
import "./main.css";
let LZString = require("lz-string");

window.setStorage = function (key, value) {
  // console.log(key + " calling compress on " + value)
  window.localStorage.setItem(key, LZString.compress(value));
  return;
};

window.getStorage = function (key) {
  try {
    return JSON.parse(LZString.decompress(window.localStorage.getItem(key)));
  } catch (err) {
    return null;
  }
};
initStorage();

const store = createStore(
  reducers,
  composeWithDevTools({ trace: true })(applyMiddleware(reduxThunk))
);

initSocket(settings, store.dispatch, store);
initPrices(store.dispatch);
initMempool(store.dispatch, store);

ReactDOM.render(
  <Provider store={store} history={ReactDOM.hashHistory}>
    <Router>
      <div>
        <Announcement />
        <Header />
        <main
          style={{ overflowY: "hidden", minWidth: isMobile ? "" : "1250px" }}
        >
          <Switch>
            <Route exact path="/" render={(props) => <Passport {...props} />} />
            <Route exact path="/qr" render={(props) => <QRGen {...props} />} />
            <Route
              exact
              path="/media"
              render={(props) => <Media {...props} />}
            />
          </Switch>
        </main>
      </div>
    </Router>
  </Provider>,
  document.getElementById("root")
);
